import React from "react"
import PropTypes from "prop-types"
import { Button } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';

const GROUPABLE_PATHS = {
  Company: "companies",
  Location: "locations",
  Asset: "assets",
  Contact: "contacts",
};

class SortableList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      items: props.items || [],
      selected: [],
      isAdding: false,
      loadingCount: 0,
      dragIndex: null,
      overIndex: null,
    };
  }

  // componentDidMount() {
  // }

  startLoading() {
    this.setState((state) => ({ loadingCount: state.loadingCount + 1 }));
  };

  stopLoading() {
    this.setState((state) => ({ loadingCount: Math.max(0, state.loadingCount - 1) }));
  };

  resequence(items) {
    return items.map((item, index) => ({ ...item, sequence: index + 1 }));
  };

  postSequence(items) {
    const { account_id, group_id } = this.props;
    if (!account_id || !group_id) return;

    const tokenEl = document.querySelector('meta[name="csrf-token"]');
    const csrfToken = tokenEl ? tokenEl.getAttribute("content") : "";
    const sequence = items.map((item) => item.id);

    this.startLoading();
    fetch(`/accounts/${account_id}/groups/${group_id}/update_sequence`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify({ sequence: JSON.stringify(sequence) }),
    })
      .finally(() => this.stopLoading());
  };

  handleDragStart(index) {
    this.setState({ dragIndex: index });
  };

  handleDragOver(index, event) {
    event.preventDefault();
    if (index !== this.state.overIndex) {
      this.setState({ overIndex: index });
    }
  };

  handleDrop(index) {
    const { dragIndex } = this.state;
    if (dragIndex === null || dragIndex === index) {
      this.setState({ dragIndex: null, overIndex: null });
      return;
    }
    const updated = this.state.items.slice();
    const [moved] = updated.splice(dragIndex, 1);
    updated.splice(index, 0, moved);
    const resequenced = this.resequence(updated);
    this.setState({ items: resequenced, dragIndex: null, overIndex: null });
    this.postSequence(resequenced);
  };

  handleDragEnd() {
    this.setState({ dragIndex: null, overIndex: null });
  };

  addGroupables() {
    const { account_id, group_id, groupable_type } = this.props;
    const { selected } = this.state;
    if (!account_id || !group_id || !selected.length) return;

    const tokenEl = document.querySelector('meta[name="csrf-token"]');
    const csrfToken = tokenEl ? tokenEl.getAttribute("content") : "";
    const groupable_ids = selected.map((item) => item.id);

    this.setState({ isAdding: true });
    this.startLoading();

    fetch(`/accounts/${account_id}/groups/${group_id}/add_groupable`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify({ groupable_type: groupable_type, groupable_ids: JSON.stringify(groupable_ids) }),
    })
      .then(response => response.json())
      .then(data => {
        const added = (data && data.items) || [];
        this.setState((state) => ({
          items: this.resequence(state.items.concat(added)),
          selected: [],
          isAdding: false,
        }));
      })
      .catch(() => this.setState({ isAdding: false }))
      .finally(() => this.stopLoading());
  };

  removeGroupable(id) {
    const { account_id, group_id } = this.props;
    if (!account_id || !group_id) return;

    const tokenEl = document.querySelector('meta[name="csrf-token"]');
    const csrfToken = tokenEl ? tokenEl.getAttribute("content") : "";

    this.startLoading();
    fetch(`/accounts/${account_id}/groups/${group_id}/remove_groupable`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify({ model_group_id: id }),
    })
      .then(response => (response.ok ? response.json() : Promise.reject(response)))
      .then(() => {
        this.setState(
          (state) => ({
            items: this.resequence(state.items.filter((item) => item.id !== id)),
          }),
          () => this.postSequence(this.state.items)
        );
      })
      .catch(() => {})
      .finally(() => this.stopLoading());
  };

  renderSelect() {
    const { account_id, groupable_type } = this.props;
    const { selected, isAdding } = this.state;
    const path = GROUPABLE_PATHS[groupable_type];
    if (!path) return null;

    let debounceTimer;

    const loadOptions = (value) => {
      return fetch(`/accounts/${account_id}/${path}/select?search=${value}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }).then(response => response.json());
    };

    const promiseOptions = (value) =>
      new Promise((resolve) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          resolve(loadOptions(value));
        }, 1000);
      });

    const customOption = (option) => (
      <div>
        <div className="d-flex align-items-center">
          <div className="mr-1">{option["title"]}</div>
          {option["badge"] && <div className="ml-auto small">{option["badge"]}</div>}
        </div>
        {option["description"] && <div className="small select-description">{option["description"]}</div>}
      </div>
    );

    return (
      <>
        <div className="mb-3" style={{ marginRight: '74px' }}>
          <AsyncSelect
            cacheOptions
            defaultOptions
            isMulti
            placeholder={this.props.placeholder || `Select ${path}...`}
            value={selected}
            getOptionLabel={o => customOption(o)}
            getOptionValue={o => o.id}
            loadOptions={promiseOptions}
            onChange={value => this.setState({ selected: value || [] })}
            isClearable
            styles={{
              valueContainer: (base) => ({ ...base, minHeight: '44px' }),
            }}
          />
        </div>
        <div className="position-absolute" style={{ width: '65px', top: '8px', right: '8px' }}>
          <Button variant="primary" style={{ width: '65px' }} disabled={isAdding || !selected.length} onClick={this.addGroupables.bind(this)}>
            Add
          </Button>
        </div>
      </>
    );
  };

  renderItems() {
    const { items, dragIndex, overIndex } = this.state;

    return items.map((item, index) => (
      <div
        key={index}
        draggable
        onDragStart={this.handleDragStart.bind(this, index)}
        onDragOver={this.handleDragOver.bind(this, index)}
        onDrop={this.handleDrop.bind(this, index)}
        onDragEnd={this.handleDragEnd.bind(this)}
        className={overIndex === index && dragIndex !== index ? "bg-light list-item" : "list-item"}
        style={{ cursor: 'move', opacity: dragIndex === index ? 0.5 : 1 }}
      >
        <div className="row align-items-center">
          <div className="col-auto text-muted">
            <i className="fa fa-bars"></i>
          </div>
          <div className="col-auto text-muted">
            {item.sequence}
          </div>
          <div className="col">
            <div className="row">
              <div className="col-md-6">
                <strong>{item.url ? <a href={item.url}>{item.name}</a> : item.name}</strong>
              </div>
              <div className="col-md-6">
                {item.description}
              </div>
            </div>
          </div>
          <div className="col-auto">
            <Button variant="light" size="sm" onClick={this.removeGroupable.bind(this, item.id)}>
              Remove
            </Button>
          </div>
        </div>
      </div>
    ));
  };

  render () {
    return (
      <div className="list position-relative">
        {this.state.loadingCount > 0 && (
          <div
            className="position-absolute d-flex align-items-center justify-content-center"
            style={{ top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.6)', zIndex: 10 }}
          >
            <i className="fa fa-spinner fa-spin fa-2x text-muted"></i>
          </div>
        )}
        {this.renderSelect()}
        {this.renderItems()}
      </div>
    );
  }
}

SortableList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    sequence: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    description: PropTypes.string,
  })),
  // name: PropTypes.string,
  account_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  group_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  groupable_type: PropTypes.oneOf(["Company", "Location", "Asset", "Contact"]),
  placeholder: PropTypes.string,
};

export default SortableList;
